/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AutoTestResult } from './AutoTestResult';
import { AutoTestRun } from './AutoTestRun';
const ExtendedAutoTestRunParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['results', /* #__PURE__ */ codecArray(AutoTestResult)],
]), AutoTestRun);
export class ExtendedAutoTestRun extends AutoTestRun {
    static decode(input) {
        return ExtendedAutoTestRunParser.decode(input).map(res => new ExtendedAutoTestRun(res));
    }
    static unsafeDecode(input) {
        return ExtendedAutoTestRun.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtendedAutoTestRunParser.encode(data);
    }
    static schema() {
        return ExtendedAutoTestRunParser.schema();
    }
}
